import React from 'react';

// Skeleton placeholder — shows a pulsing gray block while content loads.
// Used by views that adopt progressive loading instead of blocking on a
// full-page spinner.
//
// Props:
//   height   — CSS height (default '200px')
//   width    — CSS width (default '100%')
//   lines    — number of text-line placeholders (default 0, shows a block)
//   cls      — additional class name

function SkeletonLine({
  width
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "plk-skeleton-line",
    style: {
      width: width || '100%'
    }
  });
}
export default function Skeleton({
  height,
  width,
  lines,
  cls
}) {
  if (lines && lines > 0) {
    const widths = ['100%', '90%', '75%', '85%', '60%', '95%', '70%'];
    return /*#__PURE__*/React.createElement("div", {
      className: `plk-skeleton ${cls || ''}`
    }, Array.from({
      length: lines
    }, (_, i) => /*#__PURE__*/React.createElement(SkeletonLine, {
      key: i,
      width: widths[i % widths.length]
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `plk-skeleton plk-skeleton-block ${cls || ''}`,
    style: {
      height: height || '200px',
      width: width || '100%'
    }
  });
}
export function SkeletonGrid({
  rows = 5,
  cols = 4
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "plk-skeleton plk-skeleton-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "plk-skeleton-grid-header"
  }, Array.from({
    length: cols
  }, (_, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "plk-skeleton-line",
    style: {
      width: '80%'
    }
  }))), Array.from({
    length: rows
  }, (_, r) => /*#__PURE__*/React.createElement("div", {
    key: r,
    className: "plk-skeleton-grid-row"
  }, Array.from({
    length: cols
  }, (_, c) => /*#__PURE__*/React.createElement("div", {
    key: c,
    className: "plk-skeleton-line"
  })))));
}